import React, { useState, useEffect } from "react";
import CookiePreferencesModal, {
  COOKIE_CATEGORIES,
} from "./CookiePreferencesModal";
import { Link } from "react-router-dom";

const STORAGE_KEY = "cookie-preferences";

export default function CookieManager() {
  const [bannerVisible, setBannerVisible] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    // show banner only if user hasn't saved any prefs yet
    if (!localStorage.getItem(STORAGE_KEY)) {
      setBannerVisible(true);
    }
  }, []);

  const acceptAll = () => {
    const allOn = {};
    COOKIE_CATEGORIES.forEach(({ key }) => (allOn[key] = true));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(allOn));
    setBannerVisible(false);
  };

  const declineAll = () => {
    const onlyRequired = {};
    COOKIE_CATEGORIES.forEach(
      ({ key, required }) => (onlyRequired[key] = !!required)
    );
    localStorage.setItem(STORAGE_KEY, JSON.stringify(onlyRequired));
    setBannerVisible(false);
  };

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  // when the user clicks "Save preferences" in the modal
  const savePreferences = () => {
    setModalOpen(false);
    // setBannerVisible(false);
  };

  if (!bannerVisible) return null;

  return (
    <>
      {/* bottom banner */}
      <div className="fixed bottom-0 inset-x-0 bg-white text-primary shadow-lg p-5 md:p-16 flex flex-col md:flex-row gap-10 z-50">
        <div className="flex flex-col gap-5 md:gap-10">
          <h1 className="text-2xl md:text-3xl font-bold">
            Your privacy on ZORQK
          </h1>
          <p className="text-xs md:text-sm text-gray-700 flex-1">
            Essential cookies make our site work, and additional cookies help us
            understand your on-site journey so you can ZORQK it every time.
            Additional cookies are only set if you accept them, so it's
            completely up to you. Read our{" "}
            <span className="text-blue-500">
              <Link to="/policies/cookie-policy">cookie policy</Link>
            </span>{" "}
            or{" "}
            <span className="text-blue-500">
              <button onClick={openModal}>manage cookies</button>
            </span>{" "}
            at any time.
          </p>
        </div>
        <div className="flex flex-row md:flex-col gap-5">
          <button
            onClick={acceptAll}
            className="px-4 py-2 bg-accent text-white rounded hover:bg-accent/90"
          >
            Accept
          </button>
          <button
            onClick={declineAll}
            className="px-4 py-2 text-gray-700 border border-gray-300 rounded hover:bg-gray-100"
          >
            Decline
          </button>
        </div>
      </div>

      {/* full-screen preferences modal */}
      <CookiePreferencesModal
        open={modalOpen}
        onClose={closeModal}
        onSave={savePreferences}
      />
    </>
  );
}
